<template lang="pug">
  .layout-view
    controls-panel
    storage-tabs
    companies-table
</template>

<script>
import adaptationMixin from '@/mixins/adaptation.mixin.js'

import ControlsPanel from './ControlsPanel'
import StorageTabs from '../common/StorageTabs'
import CompaniesTable from './table/CompaniesTable'

export default {
  name: 'Companies',

  mixins: [adaptationMixin],

  components: {
    ControlsPanel,
    StorageTabs,
    CompaniesTable
  },

  computed: {
    offset () {
      return {
        'layout-view--offset-top': (this.isConsultant && this.isDesktop)
      }
    }
  }
}
</script>
